import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';
import { SearchFilterState } from '@/store/types';

export const useAcademicsWorkloadAllocations = (
  schoolId: number,
  year: number,
  disciplineId?: number,
  searchFilters?: SearchFilterState,
) => {
  // extract empStatusAbbr from searchFilters
  const empStatusAbbrs = searchFilters?.empStatusAbbr?.map((empStatus) => empStatus.label);
  return trpc.academic.getAcademicsWorkloadAllocations.useQuery(
    { schoolId, year, disciplineId, empStatusAbbrs },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!schoolId && !!year && !!empStatusAbbrs?.length,
    },
  );
};
